import { application } from "./controllers/application"
import Lightbox from "@stimulus-components/lightbox"
application.register("lightbox", Lightbox)
